export function getStandbyPromptSessionKey(userId?: number | null) {
  return `standby-upgrade-prompt:${userId ?? "guest"}`;
}

export function shouldResetStandbyPrompt(params: {
  hasStandbyOverLimit: boolean;
  isBypassed: boolean;
}) {
  return !params.hasStandbyOverLimit || params.isBypassed;
}

export function shouldOpenStandbyPrompt(params: {
  hasStandbyOverLimit: boolean;
  isBypassed: boolean;
  alreadyShownInSession: boolean;
}) {
  if (!params.hasStandbyOverLimit) return false;
  if (params.isBypassed) return false;
  if (params.alreadyShownInSession) return false;
  return true;
}

